import React, { useEffect, useState, useMemo } from "react";
import "../../Styles/styles-StatusTracker.css";
import { useSelector, useDispatch } from "react-redux";
import { 
    Avatar,
    Tag,
    Tooltip,
    Typography,
} from "antd";
import { getTextColorBasedOnBg } from '../../Utils/color_utils';
import Headshot from "../Player/Headshot";
import { useHeadshot } from "@hooks/useHeadshot";
import { createStatusAvatarList } from './statusTrackerUtil';

const { Text } = Typography;

export const PlayerCard = ({ player, uniqueKeys }) => {
    const {
        info: { team_logo },
    } = useSelector(({ team }) => team);
    const headshotSrc = useHeadshot(player);
    const [statusCountList, setStatusCountList] = useState([]);
    const [visibleStatusAvatars, setVisibleStatusAvatars] = useState([]);
    const [hiddenStatusAvatars, setHiddenStatusAvatars] = useState([]);
    const MAX_AVATAR_COUNT = 3;
    const {
    trackerData,
    statuses
    } = useSelector(({ statusTracker }) => statusTracker);

    useEffect(() => {
        setStatusCountList([]);
        setVisibleStatusAvatars([]);
        setHiddenStatusAvatars([]);
    }, [uniqueKeys])

    const playerUKeys = useMemo(() => {
        return new Set([...uniqueKeys].filter(uk => uk.startsWith(`${player.player_id}`))); 
    }, [uniqueKeys]);

    const playerTrackerDS = useMemo(() => {
        return Object.fromEntries(Object.entries(trackerData).filter(([key]) => playerUKeys.has(key)))
    }, [playerUKeys, trackerData])

    useEffect(() => {
        if (playerTrackerDS && Object.keys(playerTrackerDS).length > 0) {
            createStatusAvatarList(playerTrackerDS, statuses, setStatusCountList);
        }
    }, [playerTrackerDS, statuses])

    useEffect(() => {
        if (statusCountList && statusCountList.length > 0) {
            setVisibleStatusAvatars(statusCountList.slice(0, MAX_AVATAR_COUNT));
            setHiddenStatusAvatars(statusCountList.slice(MAX_AVATAR_COUNT));
        } else {
            setVisibleStatusAvatars(null);
            setHiddenStatusAvatars(null);
        }
    }, [statusCountList])

    const getHiddenStatusAvatarTooltip = () => {
        return hiddenStatusAvatars.map(([hiddenStatus, count]) => {
            const statusColor = hiddenStatus.color;
            return (
                <div>
                    <span
                        style={{
                            width: 10,
                            height: 10,
                            backgroundColor: statusColor
                        }}
                    >
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                    <span>
                        {` ${hiddenStatus.name}: ${count}`}
                    </span>
                </div>
            )
        })
    }


    return (
        <>
            <div 
                className="tracker-player-card" 
                style={
                    (statusCountList && statusCountList.length > 0) 
                    ?
                    {justifyContent: 'space-between'}
                    :
                    {justifyContent: 'flex-start'}
                }
            >
                <div style={{ width: "125px" }}>
					<Headshot
						headshot={headshotSrc}
						team_logo={team_logo}
						useOverlay={player["use_overlayed_headshot"]}
                        compact={true}
					/>
				</div>
                <div className="tracker-player-card-info">
                        <Text> {`${player?.first_name} ${player?.last_name}`} </Text>
                        <Text type="secondary"> {player?.position} | {player?.number} </Text>
                </div>
                {
                    statusCountList && statusCountList.length > 0 && (
                        <div className="tracker-player-card-status-count">
                            <Avatar.Group 
                                size={22}
                                style={{ display: 'flex', flexDirection: 'column'}}
                            >
                                {
                                    visibleStatusAvatars && visibleStatusAvatars.length > 0 && 
                                    visibleStatusAvatars.map(([status, count], idx) => {
                                        const statusColor = status?.color || 'black';
                                        const statusName = status?.name || '';
                                        return (
                                               <Tooltip
                                                title={`${statusName}: ${count}`}
                                                key={`visible-${player.player_id}-card-avatar-${idx}`}
                                               >
                                                     <Avatar 
                                                        style={{ 
                                                            backgroundColor: statusColor,
                                                            color: getTextColorBasedOnBg(statusColor)
                                                        }}
                                                        key={`${player.player_id}_avatar_${idx}`}
                                                    >
                                                        {count}
                                                    </Avatar>
                                               </Tooltip>
                                        )
                                    })
                                }

                                {
                                    hiddenStatusAvatars && hiddenStatusAvatars.length > 0 && (
                                        <Tooltip title={getHiddenStatusAvatarTooltip}>
                                            <Avatar>+{hiddenStatusAvatars.length}</Avatar>
                                        </Tooltip>
                                    )
                                }
                            </Avatar.Group>
                        </div>
                    )
                }
                
            </div>
        </>
    
    );
};
